import { actions, MARKET_DATA_STORE_NAME } from './store';
import { frontendActions } from '@cmctechnology/webinvest-store-frontend';
import { CmcWebApi } from '@cmctechnology/webinvest-api-client-web-trading';
import { CountryAlpha3Code } from '@cmctechnology/webinvest-constants';
import { Dispatch } from '@reduxjs/toolkit';
import { MARKET_DATA_API_NAMES } from './models/marketDataApiNames';

export const fetchMorningstarDetails = (topStocks: number = 10, countryIsoCode: string = CountryAlpha3Code.AUS) => {
  return async (dispatch: Dispatch<any>) => {
    const request: CmcWebApi.MarketInformation.MorningStarSummaryRequest2 = { TopStocks: topStocks, CountryIsoCode: countryIsoCode };
    try {
      const response = await frontendActions.webTradingApiCall<CmcWebApi.MarketInformation.MorningstarQuantitativeSummaryModel2>(
        MARKET_DATA_STORE_NAME,
        MARKET_DATA_API_NAMES.MorningstarQuantitativeSummaryGet2,
        request,
        dispatch
      );
      dispatch<any>(actions.morningstarFetched(response));
    } catch {}
  };
};
